import moment from 'moment';
import { OeeTrendStats, OeeSummaryFilters } from '@/libs/tpm-analytics/core/types';
import { getOeeDaily } from '@/libs/tpm-analytics/services/oee/daily.service';
import { getGlobalTargetOee, getWorldClassTarget } from '@/libs/tpm-analytics/services/oee/targets.service';

export async function getOeeTrendStats(filters: OeeSummaryFilters): Promise<OeeTrendStats> {
    const daily = await getOeeDaily(filters);
    const vals = daily.map((d) => d.oee).filter((x): x is number => typeof x === 'number' && !isNaN(x as any));
    const avg = vals.length > 0 ? vals.reduce((a, b) => a + b, 0) / vals.length : null;
    const spanMin = Math.max(1, moment(filters.to).diff(moment(filters.from), 'minutes'));
    const prevTo = moment(filters.from).toISOString();
    const prevFrom = moment(filters.from).add(-spanMin, 'minutes').toISOString();
    const prevDaily = await getOeeDaily({ ...filters, from: prevFrom, to: prevTo });
    const prevVals = prevDaily.map((d) => d.oee).filter((x): x is number => typeof x === 'number' && !isNaN(x as any));
    const prevAvg = prevVals.length > 0 ? prevVals.reduce((a, b) => a + b, 0) / prevVals.length : null;

    let vol: number | null = null;
    if (vals.length > 1) {
        const mean = avg as number;
        const diffs = vals.map((v) => (v - mean) * 100);
        const variance = diffs.reduce((s, d) => s + d * d, 0) / (diffs.length - 1);
        vol = Math.sqrt(variance);
    }
    const world = await getWorldClassTarget(filters.from, filters.to);
    const target = await getGlobalTargetOee(filters.from, filters.to);
    const imprToTarget = avg != null && target != null ? Math.max(0, (target - avg) * 100) : null;
    const imprToWorld = avg != null && world != null ? Math.max(0, (world - avg) * 100) : null;
    const fmt = (v: number | null) => (v == null ? null : `${Math.round((v as number) * 100)}%`);
    return {
        avgOee: avg == null ? null : Math.max(0, Math.min(1, avg)),
        prevAvgOee: prevAvg == null ? null : Math.max(0, Math.min(1, prevAvg)),
        volatilityPct: vol == null || !isFinite(vol) ? null : +vol.toFixed(1),
        improvementToTargetPct: imprToTarget == null ? null : +imprToTarget.toFixed(1),
        improvementToWorldClassPct: imprToWorld == null ? null : +imprToWorld.toFixed(1),
        targetOeePctText: fmt(target),
        worldClassPctText: fmt(world),
    } as OeeTrendStats;
}


